const ACCESS_KEY = 'cabin.access_token.v1';
const REFRESH_KEY = 'cabin.refresh_token.v1';
const USER_KEY = 'cabin.user.v1';

export interface StoredUser {
  user_id: string;
  email: string;
  display_name: string;
  avatar_url: string | null;
}

export const tokenStorage = {
  getAccess(): string | null {
    return localStorage.getItem(ACCESS_KEY);
  },
  getRefresh(): string | null {
    return localStorage.getItem(REFRESH_KEY);
  },
  getUser(): StoredUser | null {
    const raw = localStorage.getItem(USER_KEY);
    if (!raw) return null;
    try {
      return JSON.parse(raw) as StoredUser;
    } catch {
      return null;
    }
  },
  setAll(access: string, refresh: string, user: StoredUser): void {
    localStorage.setItem(ACCESS_KEY, access);
    localStorage.setItem(REFRESH_KEY, refresh);
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  },
  setAccess(access: string): void {
    localStorage.setItem(ACCESS_KEY, access);
  },
  setRefresh(refresh: string): void {
    localStorage.setItem(REFRESH_KEY, refresh);
  },
  clear(): void {
    localStorage.removeItem(ACCESS_KEY);
    localStorage.removeItem(REFRESH_KEY);
    localStorage.removeItem(USER_KEY);
  },
};
